import { Component, OnDestroy, OnInit } from '@angular/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-waygate-rma-product-view-details-modal',
  standalone: false,
  templateUrl: './waygate-rma-product-view-details-modal.component.html',
  styleUrl: './waygate-rma-product-view-details-modal.component.scss'
})
export class WaygateRmaProductViewDetailsModalComponent implements OnInit, OnDestroy {
 
  product: any = null;
 
  private destroy$ = new Subject<void>();
 
  constructor(
    private launchDialogService: LaunchDialogService
  ) {}
 
  ngOnInit(): void {
    this.launchDialogService.data$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        console.log('View Details Modal Data:', data);
 
        this.product = data?.product;
 
        console.log('Product:', this.product);
      });
  }
 
  closeModal(): void {
  this.launchDialogService.closeDialog('product-details-close');
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
